const tasks = {
  notAvailable: 'Not Available',
  executing: 'Executing',
  finished: 'Finished',
  success: 'Success',
  any: 'Any',
  general: {
    search: 'Search by UUID',
    serialNmbr: 'Serial Number',
  },
  selectors: {
    selector4: {
      last7Days: 'Last 7 days',
      custom: 'Custom',
    },
  },
  table: {
    siteName: 'Site Name',
    date: 'Date',
    status: 'Status',
    id: 'ID',
    id_detail: 'ID Detail',
    serial_number: 'Serial Number',
    commandtype: 'Command Type',
    entitytype: 'Entity Type',
    started_at: 'Started At',
    finished_at: 'Finished At',
  },
  modal: {
    title: 'Controller Task-Detail',
    header: 'Header',
  },
};

export default tasks;
